import {
  COUNTRY_FILTER,
  ZONE_FILTER,
  STATUS_FILTER,
  BRANCH_NAME_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    country_id: 1,
    zone_id: "",
    branch_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "branch_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
    ],
  };

  const navigatePage = { back: "/branch-list" };

  const headerName = "Branch";

  const validationType = "BranchCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "branch_masters",
      initialPayload: {
        modelName: "branch_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "branch_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "branch_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Country Name", value: "country.country_name" },
    { label: "Zone Name", value: "zone.zone_name" },
    { label: "Branch Name", value: "branch_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/branch-create",
    edit: "/branch-create",
    view: "/branch-view",
  };

  const searchfields = [
    "branch_name",
    "country.country_name",
    "zone.zone_name",
  ];

  const headerName = "Branch";
  const endpoint = "/getRecords";
  const exportFileName = "BranchData.xlsx";

  const filterConfig = [
    COUNTRY_FILTER,
    ZONE_FILTER,
    BRANCH_NAME_FILTER,
    STATUS_FILTER,
  ];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "branch_masters",
  schema: schema,
  include: [
    { model: "country_masters", as: "country" },
    { model: "zone_masters", as: "zone" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
